import { Text } from "@flat-ui";
import { CREDITS_DISPLAY_NAME } from "@src/constants/credit-constants";
import { FaroCoreApiTypes } from "@stellar/core-api-client";
import { formatNumber } from "@utils/data-display";
import { Dialog } from "@flat-ui";

interface Props {
  /** The credit package to request quote for */
  selectedPackage: FaroCoreApiTypes.StripeProduct;

  /** Whether the dialog is loading state while sending quote request */
  isLoading: boolean;

  /** Callback to close the dialog */
  onClose: () => void;

  /** Callback to confirm the action */
  onConfirm: () => void;
}

/**
 * Render a dialog to get confirmation before sending request for a quote.
 */
export function QuoteConfirmationDialog({
  selectedPackage,
  isLoading,
  onClose,
  onConfirm,
}: Props): JSX.Element {
  return (
    <Dialog
      open={true}
      title="Request a quote"
      onCancel={onClose}
      onClose={onClose}
      onConfirm={onConfirm}
      showSpinner={isLoading}
    >
      <Text
        variant="bodyL"
        sx={{
          marginBottom: "24px",
          display: "block",
        }}
      >
        You are about to request a quote for{" "}
        <var>
          <strong>
            {formatNumber(selectedPackage.tokenAmount)} {CREDITS_DISPLAY_NAME}
          </strong>
        </var>
        .
      </Text>

      <Text variant="bodyL">Are you sure you want to proceed?</Text>
    </Dialog>
  );
}
